import {
  AdvancedQueryColumnFilter,
  AdvancedQueryColumnSort,
  CodeGetDto,
  CreateCodeRequest,
  CodeDetailDto,
  UpdateCodeRequest,
  QuickAddCodeOptionRequest,
  OptionItemDto,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  Response,
  AdvancedQueryPage,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class CodesService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static getAll(
    params: {
      /**  */
      codeClass?: string;
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<CodeGetDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/codes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        CodeClass: params['codeClass'],
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted']
      };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateCodeRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<CodeDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/codes';

      const configs: IRequestConfig = getConfigs('post', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<CodeDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/codes/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: UpdateCodeRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<CodeDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/codes/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static quickAdd(
    params: {
      /** requestBody */
      body?: QuickAddCodeOptionRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<OptionItemDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/codes/quick-add';

      const configs: IRequestConfig = getConfigs('post', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDocumentTypeCodeOptions(options: IRequestOptions = {}): Promise<Response<List<OptionItemDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/codes/document-type';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getLevelOfServiceCodeOptions(options: IRequestOptions = {}): Promise<Response<List<OptionItemDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/codes/levels-of-service';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDispositionCodeOptions(options: IRequestOptions = {}): Promise<Response<List<OptionItemDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/codes/disposition';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getNonRepairableReasonOptions(options: IRequestOptions = {}): Promise<Response<List<OptionItemDto<string>>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/codes/non-repairable-reason';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getCustomerRejectionReasonOptions(
    options: IRequestOptions = {}
  ): Promise<Response<List<OptionItemDto<string>>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/codes/customer-rejection-reason';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getOptionsByClass(
    params: {
      /**  */
      codeClass?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<List<OptionItemDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/codes/options';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { codeClass: params['codeClass'] };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}
